"use client";

import { useEffect, useState } from "react";
import { useLocale } from "@/components/locale-provider";

/**
 * Shown when the browser reports offline. Helps store review of the Capacitor
 * shell (and PWA installs) so a blank WebView doesn't look like a crash.
 */
export function OfflineBanner() {
  const { t } = useLocale();
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const sync = () => setOffline(!navigator.onLine);
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[60] safe-top border-b border-ios-separator/60 bg-ios-bg/95 px-4 py-3 text-center backdrop-blur-md"
    >
      <p className="text-[15px] font-semibold text-ios-label">{t.offline.title}</p>
      <p className="mt-0.5 text-[13px] text-ios-label-secondary">{t.offline.body}</p>
      {/* A plain <a> on purpose: offline, a Next <Link> client transition can
          wedge on failed RSC fetches; a full navigation lets the service
          worker answer with the cached page. */}
      {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
      <a href="/offline" className="mt-1 inline-block text-[13px] font-semibold text-ios-accent-text">
        {t.offline.browseOffline}
      </a>
    </div>
  );
}
